function getBigItemsIndexes(
  realLength: number,
  extraItemIndexes?: number[],
): boolean[] {
  const bigPositions = Array(realLength)

  if (realLength <= 3) {
    // When there is 1, 2 or 3 items in total, all are big.
    // The generic rules below (for 4+ items) would return (big-small-small) but we prefer (big-big-big).
    bigPositions.fill(true)
  } else {
    // Item '0' is big (usually the product image1).
    // The other items defaults to small images. Next steps will make some of them big.
    bigPositions[0] = true
    bigPositions.fill(false, 1)

    // 'extra' items are always big.
    if (extraItemIndexes) {
      for (const extraItemIndex of extraItemIndexes) {
        bigPositions[extraItemIndex] = true
      }
    }

    // After two small items, the next item, if it exists, is big.
    // (...-small-small-small-...) becomes (...-small-small-big-...).
    bigPositions.forEach((_, itemIndex) => {
      if (
        bigPositions[itemIndex] === false &&
        bigPositions[itemIndex + 1] === false &&
        itemIndex + 2 < realLength
      ) {
        bigPositions[itemIndex + 2] = true
      }
    })

    // Orphan small items are forbidden. One of their neighbor must be small as well.
    // (...-big-small-big-...) becomes (...-big-big-big-...).
    // (...-big-small) becomes (...-big-big).
    // (...-small-small-...) remains unchanged.
    bigPositions.forEach((isBigItem, itemIndex) => {
      if (
        isBigItem === false &&
        bigPositions[itemIndex - 1] !== false &&
        bigPositions[itemIndex + 1] !== false
      ) {
        bigPositions[itemIndex] = true
      }
    })
  }

  return bigPositions
}

/**
 * Function used to determine if the item is big in the grid
 * on the mobile version of the carousel.
 *
 * New: we can now take into account extra items indexes. Extra items are
 * **always** big and can be injected at arbitrary positions. This could
 * impact the size calculation, since we could have orphan small items. Extra items
 * are already taken into account in the `realLength` parameter.
 *
 */
export function isBig(
  index: number,
  realLength: number,
  extraItemsIndexes?: number[],
): boolean {
  return getBigItemsIndexes(realLength, extraItemsIndexes)[index]
}
